/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useMutation } from "@apollo/react-hooks";
import ReminderBell from '../../../../images/icons/remindersbell.svg';
import ApolloClient from "../../../../api/client";
import Ql from '../../../../api/ql';
import { UPDATE_LAST_REMINDER } from '../../utils/graphql';

export default function ReminderStart({ setStage, exitFunc }) {
  const [userId, setUserId] = useState(null);
  const [updateLastReminderMutation] = useMutation(UPDATE_LAST_REMINDER, { client: ApolloClient });

  useEffect(() => {
    (async () => {
      if (!userId) {
        const result = await new Ql('userData').get().then(response => response.data.userGet.uuid);

        setUserId(result);
      }
    })()
  }, []);

  useEffect(() => {
    if (!userId) { return; }

    updateLastReminderMutation({
      variables: { userId },
    });
  }, [userId])

  return(
    <>
      <img src={ReminderBell}/>
      <span>Tens seguros fora da MUDEY?</span>
      <p>Diz-nos quais são e nós lembramos-te 30 dias antes da renovação. E procuramos, na altura, melhores opções para ti — sem compromisso.</p>
      <div id="buttons">
        <button onClick={() => setStage('FORM')} className="reminder-button-active">Quero activar o lembrete gratuito</button>
        <button onClick={exitFunc} className="reminder-button-inactive">Agora não</button>
      </div>
    </>
  );
}